import React from 'react';
import { Icon } from './Icon.js';
export const IconMaskCircleFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,0C2.691,0,0,2.691,0,6s2.691,6,6,6,6-2.691,6-6S9.309,0,6,0Zm0,1.5c.3,0,.593.032.877.089.074.322.123.626.123.911,0,2.481-2.019,4.5-4.5,4.5-.285,0-.588-.049-.911-.124-.056-.284-.089-.576-.089-.876C1.5,3.519,3.519,1.5,6,1.5Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconMaskCircleFill12.js.map